export * from './src/pricing-plans-settings-v1-pricing-plans-settings-pricing-plans-settings.universal.js';
